import React from 'react';
import * as PropTypes from 'prop-types';

import EmptyState from '@components/shared/EmptyState';

const CommentsEmptyState = ({ size, title, caption }) => (
  <EmptyState
    size={size}
    title={title}
    caption={caption}
    img="/images/girl-with-pencil.svg"
  />
);

CommentsEmptyState.defaultProps = {
  title: 'Be first to leave a comment'
};

CommentsEmptyState.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  caption: PropTypes.string
};

export default CommentsEmptyState;
